export default "__VITE_ASSET__e4488562__"